module.exports = __webpack_public_path__ + "static/img/image2.f52fddd8.png";